import axios from 'axios';

interface SideloadedProps {
    __data_key?: string;
    __seo?: Record<string, Record<string, unknown>>;
    [key: string]: unknown;
}

/**
 * If the Inertia page props contain a __data_key, fetch the full
 * side-loaded data from Redis via the hydration endpoint and merge
 * it back into the props object.
 *
 * Returns the props unchanged if no __data_key is present.
 */
export async function hydrateIfNeeded(props: SideloadedProps): Promise<SideloadedProps> {
    if (!props.__data_key) {
        return props;
    }

    const key = props.__data_key;

    try {
        const response = await axios.get(`/api/hydrate/${key}`, {
            timeout: 10000,
        });

        const hydratedData = response.data as Record<string, unknown>;

        // Merge: keep shared props, overlay hydrated page-specific props
        const { __data_key, __seo, ...existingProps } = props;

        return { ...existingProps, ...hydratedData };
    } catch (error) {
        console.error('[sideload] Hydration failed, reloading page', error);
        window.location.reload();

        // Return existing props while reload is in progress
        return props;
    }
}
